import React, { forwardRef } from 'react';

import Grid from '@mui/material/Grid';

import Label from 'components/Label';

import { StyledInput } from './styles';

function Input({ name, label, md, xs, item, error, disabled, labelColor, textColor, ...props }, ref) {
  return (
    <>
      {item ? (
        <Grid md={md} xs={xs} item>
          <Label htmlFor={name} className="textLabel" style={labelColor ? { color: labelColor } : undefined}>
            {label}
          </Label>
          <StyledInput
            ref={ref}
            id={name}
            name={name}
            $textColor={textColor}
            error={error}
            disabled={disabled}
            {...props}
          />
        </Grid>
      ) : (
        <>
          <Label htmlFor={name} className="textLabel" style={labelColor ? { color: labelColor } : undefined}>
            {label}
          </Label>
          <StyledInput
            ref={ref}
            id={name}
            name={name}
            $textColor={textColor}
            error={error}
            disabled={disabled}
            {...props}
          />
        </>
      )}
    </>
  );
}

export default forwardRef(Input);
